import { GetTeamDetailsDocument } from './use-team.generated'

export default function () {
  const isFetching = ref(false)

  const { execute } = useQuery({
    query: GetTeamDetailsDocument,
    fetchOnMount: false,
    // TODO: Change the line below to `({ id }) => !id` if/when they merge the
    // following PR in villus: https://github.com/logaretm/villus/pull/213
    skip: () => !isFetching.value,
    tags: ['teams'],
  })

  async function fetchTeam(id: string) {
    let name = ''
    let parent = { id: '', name: '' }

    async function fetchOnePageOfMembers(after?: string):
    Promise<[string[], string?]> {
      const response = await execute({ variables: { id, after } })
      name = response.data?.organization.team.name ?? name
      parent = response.data?.organization.team.parent ?? parent
      const memberData = response.data?.organization.team.members
      const members = getListOfNodes(memberData).map(m => m.id)

      if (memberData?.pageInfo.hasNextPage)
        return [members, memberData.pageInfo.endCursor!]
      else
        return [members, undefined]
    }

    let after
    let onePageOfMembers
    let members: string[] = []

    isFetching.value = true
    do {
      [onePageOfMembers, after] = await fetchOnePageOfMembers(after)
      members = members.concat(onePageOfMembers)
    } while (after)
    isFetching.value = false

    return { members, name, parent }
  }

  return { fetchTeam, isFetching }
}
